import {
  Alert,
  AlertTitle,
  Box,
  Link,
  Paper,
  Typography,
} from '@mui/material';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import './ApiRoute.css';

function ApiRoute() {
  return (
    <div className="ApiRoute">
      <Alert severity="info" sx={{ marginBottom: 2 }}>
        <AlertTitle>REST API</AlertTitle>
        <Typography variant="body2">
          Browse and try the public REST endpoints below. Authenticate with a
          personal API token from the{' '}
          <strong>API Keys</strong> tab — paste it into the{' '}
          <strong>Authorize</strong> dialog as a bearer token. The full spec
          is available at{' '}
          <Link href="/openapi.yml" target="_blank" rel="noopener noreferrer">
            /openapi.yml
          </Link>
          .
        </Typography>
      </Alert>

      <Paper variant="outlined" sx={{ p: { xs: 1, sm: 2 } }}>
        <SwaggerUI
          url="openapi.yml"
          persistAuthorization={true}
          defaultModelExpandDepth={-1}
          docExpansion="none"
        />
      </Paper>

      <Box sx={{ marginBottom: '6vmin' }} />
    </div>
  );
}

export default ApiRoute;
